import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

export const Home = () => {
  const { t } = useTranslation('common')
  return (
    <section className="section">
      <h1>{t('pages.home.title')}</h1>
      <p>{t('pages.home.description')}</p>
    </section>
  )
}

export const Posts = () => {
  const { t } = useTranslation('common')
  return (
    <section className="section">
      <h1>{t('pages.posts.title')}</h1>
      <p>{t('pages.posts.description')}</p>
    </section>
  )
}

export const About = () => {
  const { t } = useTranslation('common')
  return (
    <section className="section">
      <h1>{t('pages.about.title')}</h1>
      <p>{t('pages.about.description')}</p>
    </section>
  )
}

export const routes: Record<string, ReactNode> = {
  '/': <Home />,
  '/posts': <Posts />,
  '/about': <About />,
}
